import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { DatahubService } from '../../services/datahub.service';
import { CostCenterLookupComponent } from '../cost-center-lookup/cost-center-lookup.component';

@Component({
  selector: 'cost-center-form-field',
  templateUrl: './cost-center-form-field.component.html',
  standalone: false,
})
export class CostCenterFormFieldComponent implements OnDestroy {
  @Output() readonly valueChanged = new EventEmitter<string>();

  costCenterCtrl = this.datahub.costCenter.getCostCenterFormControl();

  get costCenterDescription(): string {
    return this.datahub.costCenter.description;
  }

  private readonly subscriber: Subscription = this.costCenterCtrl.valueChanges.subscribe((value) => {
    this.valueChanged.emit(value.trim());
  });

  constructor(
    private readonly datahub: DatahubService,
    private readonly dialog: MatDialog,
  ) {}

  ngOnDestroy(): void {
    this.subscriber.unsubscribe();
  }

  public openCostCenterSearchModal(): void {
    this.dialog.open(CostCenterLookupComponent, {
      maxHeight: '900px',
      width: '90%',
      maxWidth: '900px',
    });
  }
}
